import { LanguageCode } from "@timeedit/registration-schemas";
import { ConfigProvider } from "@timeedit/ui-components/antd";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import "dayjs/locale/sv";
import { PropsWithChildren, useEffect } from "react";
import { useAppDispatch } from "../redux/hooks";
import { setLocale } from "../redux/slices/lang";
import { locales } from "./locales";

interface LocaleWrapper extends PropsWithChildren {
  localeId: LanguageCode;
}

export function LocaleWrapper({
  children,
  localeId,
}: LocaleWrapper): React.JSX.Element {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setLocale({ locale: locales[localeId] }));
  }, [dispatch, localeId]);

  const locale = locales[localeId];
  dayjs.locale(locale.locale);

  return <ConfigProvider locale={locale}>{children}</ConfigProvider>;
}
